var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-menu',{class:_vm.collapse ? 'is-collapse' : '',attrs:{"collapse":_vm.collapse,"default-active":_vm.$route.path,"router":""}},_vm._l((_setup.menus),function(item){return _c(_setup.MlMenuItem,{key:item.code,attrs:{"menu":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }